import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Mail, Download, PlayCircle, ArrowLeft } from 'lucide-react';
export function ThankYouPage() {
  return <div className="min-h-screen bg-cream font-body text-charcoal flex flex-col items-center justify-center py-12 px-4" data-id="element-274">
      <div className="max-w-2xl w-full" data-id="element-275">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        duration: 0.6,
        bounce: 0.4
      }} className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-12 text-center relative overflow-hidden" data-id="element-276">
          {/* Decorative background element */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-green/5 rounded-t-3xl border-b border-green/10" data-id="element-277"></div>

          <div className="relative z-10" data-id="element-278">
            <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring',
            stiffness: 200
          }} className="w-24 h-24 bg-green text-white rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-green/30" data-id="element-279">
              <CheckCircle className="w-12 h-12" data-id="element-280" />
            </motion.div>

            <h1 className="font-heading font-black text-3xl md:text-4xl text-charcoal mb-4" data-id="element-281">
              ¡Felicidades! Tu compra fue exitosa
            </h1>

            <p className="text-lg text-warm-gray mb-10" data-id="element-282">
              Tu pedido está confirmado. Revisa tu correo electrónico para
              acceder al <strong data-id="element-283">Protocolo SOS Nervio Ciático</strong>.
            </p>

            <div className="bg-cream rounded-2xl p-6 mb-10 text-left border border-gray-100" data-id="element-284">
              <h2 className="font-bold text-charcoal mb-6 text-center uppercase tracking-wider text-sm" data-id="element-285">
                ¿Qué sigue ahora?
              </h2>

              <div className="space-y-6" data-id="element-286">
                <div className="flex items-start" data-id="element-287">
                  <div className="bg-navy/10 text-navy w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-288">
                    <Mail className="w-5 h-5" data-id="element-289" />
                  </div>
                  <div data-id="element-290">
                    <h3 className="font-bold text-charcoal mb-1" data-id="element-291">
                      1. Revisa tu bandeja de entrada
                    </h3>
                    <p className="text-sm text-warm-gray" data-id="element-292">
                      Te enviamos un correo con el asunto "Tu acceso al
                      Protocolo SOS". (Revisa la carpeta de spam por si acaso).
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-293">
                  <div className="bg-orange/10 text-orange w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-294">
                    <Download className="w-5 h-5" data-id="element-295" />
                  </div>
                  <div data-id="element-296">
                    <h3 className="font-bold text-charcoal mb-1" data-id="element-297">
                      2. Descarga tu guía
                    </h3>
                    <p className="text-sm text-warm-gray" data-id="element-298">
                      Haz clic en el enlace seguro dentro del correo para
                      descargar todo el material en tu celular o computadora.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-299">
                  <div className="bg-green/10 text-green w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mr-4" data-id="element-300">
                    <PlayCircle className="w-5 h-5" data-id="element-301" />
                  </div>
                  <div data-id="element-302">
                    <h3 className="font-bold text-charcoal mb-1" data-id="element-303">
                      3. Comienza el Día 1 hoy mismo
                    </h3>
                    <p className="text-sm text-warm-gray" data-id="element-304">
                      Ve directamente a la "Técnica de la Esfinge de 4 Minutos"
                      para empezar a aliviar la presión hoy.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center" data-id="element-305">
              <div className="text-sm text-warm-gray mb-6" data-id="element-306">
                Tu pedido:{' '}
                <strong className="text-charcoal" data-id="element-307">
                  Protocolo SOS Nervio Ciático - $6.39 USD
                </strong>
              </div>

              <button onClick={() => window.location.hash = ''} className="flex items-center text-navy hover:text-orange font-bold transition-colors" data-id="element-308">
                <ArrowLeft className="w-4 h-4 mr-2" data-id="element-309" />
                Volver a la página principal
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}